/* eslint-disable no-unused-vars */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/alt-text */
import CustomButton from "@/ui/Buttons/CustomButton";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import validationText from "@/json/messages/validationText";
import { useForm, Controller } from "react-hook-form";
import { error } from "console";
import { useGetroleslist } from "@/hooks/useRoles";
import { useAddAdmin } from "@/hooks/useAdmin";
import useNotiStack from "@/hooks/useNotistack";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Typography from "@mui/material/Typography";
import Image from "next/image";
import assets from "@/json/assest";
import { useGetAdminlist, useAddAdminList } from "@/hooks/useAdmin";
import ManageAdminTable from "@/components/Tables/ManageAdminTable";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import { useQuery, useQueryClient } from "react-query";
import { useUpdateProfile } from "@/hooks/useUser";
import CustomBorderButton from "@/ui/Buttons/CustomBorderButton";
import CloseIcon from "@mui/icons-material/Close";
import assest from "@/json/assest";
import styled from "@emotion/styled";
import { baseUrl } from "@/api/endpoints";
import { useSnackbar } from "notistack";

//=== TYPES ====
interface updateprofileInput {
  full_name: string;
}

const UploadImage = styled(Box)`
  .upload-image-wrap {
    margin-top: -35px;
    text-align: center;
    @media (max-width: 767px) {
      margin-top: 0;
    }
    figure {
      border: 2px solid #8d99ae;
      height: 100%;
      width: 100%;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
    .upload-image {
      position: relative;
      max-width: 104px;
      margin: 0 auto;
      overflow-y: hidden;
      input[type="file"] {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
      .click-image {
        background: #edf2f4;
        height: 30px;
        width: 30px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
    p {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      margin-top: 20px;
      color: #2b2d42;
      margin-bottom: 0;
    }
  }
`;

// schema

const schema = yup
  .object()
  .shape({
    full_name: yup
      .string()
      .trim()
      // .matches(
      //   /^\S*$/,
      //   "full name is not enter"
      // )
      .required("Name  is required!")
      .max(50, "Oops! You can not enter more the 50 Char"),
  })
  .required();

export default function Createadmin({
  handleClose,
  fetchListRole,
  allAdminList,
  userdata,
}: any) {
  const [page1, setPage1] = useState(1);
  const [page2, setPage2] = useState(1);
  const [Perpage, setPerpage] = React.useState<string>("10");

  const queryClient = useQueryClient();

  const [allpratnersList, setAllPartnerList] = React?.useState("");
  const [profileFile, setProfileFile] = useState<string | null | any>(null);
  const [ImageOriginal2, setImageOriginal2] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const {
    handleSubmit,
    control,
    register,
    reset,
    watch,
    setValue,

    formState: { errors },
  } = useForm<updateprofileInput>({
    resolver: yupResolver(schema),
    defaultValues: {
      full_name: userdata?.full_name,
    },
  });

  const { toastSuccess, toastError } = useNotiStack();
  const {
    data: udpateprofile,
    mutate,
    isSuccess,
    isLoading,
  } = useUpdateProfile();
  const handelchange = (data: updateprofileInput) => {
    handleClose();

    const formData = new FormData();

    formData.append("full_name", data.full_name);

    formData.append(
      "profile_image",
      profileFile === null ? ImageOriginal2 : profileFile
    );

    mutate(formData);
    //adminUser()
  };

  const handleFileUpload = (e: HTMLInputElement | unknown | any) => {
    // console.log(e.target.files[0], "PDFfile");

    if (
      e.target.files[0]?.type === "image/jpeg" ||
      e.target.files[0]?.type === "image/png" ||
      e.target.files[0]?.type === "image/jpg"
    ) {
      setProfileFile(e.target.files[0]);
    } else {
      // eslint-disable-next-line no-use-before-define
      enqueueSnackbar("Please upload a valid document", {
        variant: "error",
      });
    }
  };

  const onErrorImg = (ev: { target: { src: string } }) => {
    ev.target.src = assest.noimg;
  };

  useEffect(() => {
    if (userdata) {
      setImageOriginal2(userdata?.profile_image);
    }
  }, [userdata]);

  return (
    <Box className="serviceModal">
      <Box className="serviceModalTxt">
        <h4>Profile Update</h4>
        <p>Here you can Update your profile name</p>

        <UploadImage>
          <Box className="upload-image-wrap">
            <Box className="upload-image">
              <figure>
                {typeof profileFile === "object" && profileFile !== null ? (
                  <Image
                    src={URL.createObjectURL(profileFile)}
                    width={100}
                    height={100}
                    alt=""
                  />
                ) : (
                  <img
                    src={
                      ImageOriginal2 !== null
                        ? `${baseUrl}/uploads/user/profile_images/${ImageOriginal2}`
                        : assest.noImage
                    }
                    width={105}
                    height={105}
                    onError={onErrorImg}
                    alt={""}
                  />
                )}
              </figure>
              <Box className="click-image">
                <Image src={assest.cameraIcon} width={12} height={12} alt="" />
              </Box>
              <input
                type="file"
                onChange={handleFileUpload}
                accept="image/gif, image/jpeg, image/jpg"
              />
            </Box>
            <Typography variant="body1">Upload Image</Typography>
          </Box>
        </UploadImage>

        <Box className="inputWrapper">
          <label>
            Name <sup>*</sup>
          </label>
          <input
            type="text"
            placeholder="Enter user name"
            {...register("full_name")}
          />
          {errors.full_name && (
            <p
              style={{
                color: "red",
                textAlign: "left",
                fontSize: "15px",
              }}
            >
              {errors.full_name.message}
            </p>
          )}
          {errors?.full_name?.type === "pattern" && (
            <p
              style={{
                color: "red",
                textAlign: "left",
                fontSize: "15px",
              }}
            >
              Alphabetical characters only
            </p>
          )}
        </Box>
        <button
          style={{
            position: "absolute",
            top: "6px",
            right: "11px",
            border: "0px",
            background: "transparent",
            cursor: "pointer",
          }}
          type="button"
          onClick={handleClose}
        >
          <span>
            <CloseIcon />
          </span>
        </button>

        <Box className="buttonGroup">
          <CustomButton
            type="button"
            onClick={handleSubmit(handelchange)}
            loading={isLoading}
          >
            <p>Update Profile</p>
          </CustomButton>
        </Box>
      </Box>

      {/* <ManageAdminTable allAdminLists={allAdminLists} /> */}
    </Box>
  );
}
